// extracted by mini-css-extract-plugin
export default {"newsfeedCard":"f8-z"};